import { Component } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-loading',
    standalone: true,
    imports: [
        ProgressSpinnerModule,
        TranslocoModule
    ],
    templateUrl: './loading.component.html',
    styleUrl: './loading.component.scss'
})
export class LoadingComponent {

}
